<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>

<!-- fixed-ads -->
<ins class="adsbygoogle" style="display:inline-block;text-align:center;width:320px;height:50px"
    data-ad-client="ca-pub-3372584184973915" data-ad-slot="3772952534"></ins>